<script setup lang="ts">
import BaseLayout from '@/components/base/BaseLayout.vue'
import TableContainer from '@/components/base/containers/TableContainer.vue'
import basicAnalyticCard from '@/components/card/basicAnalyticCard.vue'
import ForbiddenAccess from '@/components/permissions/ForbiddenAccess.vue'
import { moduleName } from '@/enums/moduleNames'
import { computed, onBeforeMount, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

import TotalViewCircle from '@/components/analytics/TotalViewCircle.vue'
import TotalViewInsight from '@/components/analytics/TotalViewInsight.vue'
import TotalViewInstitution from '@/components/analytics/TotalViewIntitution.vue'
import TotalViewResearch from '@/components/analytics/TotalViewResearch.vue'
import TotalViewResearchAndInsight from '@/components/analytics/TotalViewResearchAndInsight.vue'
import { getTotalPublishedInsight, getTotalPublishedResearch, getTotalVerifiedUser } from '@/service/analytics/basicAnalytics'
import { communityResearchStore } from '@/stores/communityResearch/communityResearch'
import { userPermissionStore } from '@/stores/user/permission'

const router = useRouter()
const userPermission = userPermissionStore()
const communityResearch = communityResearchStore()

const showNoPermission = ref<boolean>(false)
const showTotalRequest = ref<boolean>(true)

interface totalViewRecord {
  total: number, 
  target_date: Date,
  action: string
}

// analytic 
const totalVerifiedUser = ref<number>(0)
const totalPublishedResearch = ref<number>(0)
const totalPublishedNews = ref<number>(0)

const totalViewNonUserResearch = ref<totalViewRecord[]>([])
const totalViewUserResearch = ref<totalViewRecord[]>([])
// const totalViewMergedResearch = ref<totalViewRecord[]>([])
  const totalViewNonUserInsight = ref<totalViewRecord[]>([])
const totalViewUserInsight = ref<totalViewRecord[]>([])
const totalViewMergedInsight = ref<totalViewRecord[]>([])

const fetchState = reactive({
  totalRequest: true,
  basicCount: true,
  fetchingVerifiedUser: true,
  fetchingPublishedResearch: true,
  fetchingPublishedNews: true,
  fetchingTotalViewSignedInUserForResearchInSevenDaysBack: true,
  fetchingTotalViewNonUserForResearchInSevenDaysBack: true,
  fetchingTotalViewSignedInUserForInsightInSevenDaysBack: true,
  fetchingTotalViewNonUserForInsightInSevenDaysBack: true,
})

async function fetchTotalVerifiedUser() {
  fetchState.fetchingVerifiedUser = true
  const result = (await getTotalVerifiedUser())
  if (result?.data?.data?.total != null) {
    totalVerifiedUser.value = result.data.data.total;
  } else {
    totalVerifiedUser.value = 0; 
  }
  fetchState.fetchingVerifiedUser = false
}

async function fetchTotalPublishedResearch() {
  fetchState.fetchingPublishedResearch = true
  const result = (await getTotalPublishedResearch())
  if (result?.data?.data?.total != null) {
    totalPublishedResearch.value = result.data.data.total;
  } else {
    totalPublishedResearch.value = 0; 
  }
  fetchState.fetchingPublishedResearch = false
}
async function fetchTotalPublishedInsight() {
  fetchState.fetchingPublishedNews = true
  const result = (await getTotalPublishedInsight())
  if (result?.data?.data?.total != null) {
    totalPublishedNews.value = result.data.data.total;
  } else {
    totalPublishedNews.value = 0; 
  }
  fetchState.fetchingPublishedNews = false
}

// function mergeTotalViewResearch () {
//   if (
//     totalViewUserResearch.value.length === totalViewNonUserResearch.value.length && 
//     totalViewUserResearch.value[0].target_date === totalViewNonUserResearch.value[0].target_date && 
//     totalViewUserResearch.value[totalViewUserResearch.value.length - 1].target_date === totalViewNonUserResearch.value[totalViewNonUserResearch.value.length - 1].target_date
//   ) {
//     for (var x = 0; x < totalViewUserResearch.value.length; x++) {
//       totalViewMergedResearch.value.push({
//         total: totalViewUserResearch.value[x].total + totalViewNonUserResearch.value[x].total,
//         target_date: totalViewUserResearch.value[x].target_date,
//         action: "ENTER"
//       })
//     }
//   }
// }

// function mergeTotalViewInsight () {
//   if (
//     totalViewUserInsight.value.length === totalViewNonUserInsight.value.length && 
//     totalViewUserInsight.value[0].target_date === totalViewNonUserInsight.value[0].target_date && 
//     totalViewUserInsight.value[totalViewUserInsight.value.length - 1].target_date === totalViewNonUserInsight.value[totalViewNonUserInsight.value.length - 1].target_date
//   ) {
//     for (var x = 0; x < totalViewUserInsight.value.length; x++) {
//       totalViewMergedInsight.value.push({
//         total: totalViewUserInsight.value[x].total + totalViewNonUserInsight.value[x].total,
//         target_date: totalViewUserInsight.value[x].target_date,
//         action: "ENTER"
//       })
//     }
//   }
// }

// async function fetchTotalViewSignedInUserForResearchInSevenDaysBack() {
//   fetchState.fetchingTotalViewSignedInUserForResearchInSevenDaysBack = true
//   const result = (await getTotalViewSignedInUserForResearchInSevenDaysBack())
//   totalViewUserResearch.value = result.data.data
//   fetchState.fetchingTotalViewSignedInUserForResearchInSevenDaysBack = false
// }
// async function fetchTotalViewNonUserForResearchInSevenDaysBack() {
//   fetchState.fetchingTotalViewNonUserForResearchInSevenDaysBack = true
//   const result = (await getTotalViewNonMemberForResearchInSevenDaysBack())
//   totalViewNonUserResearch.value = result.data.data
//   fetchState.fetchingTotalViewNonUserForResearchInSevenDaysBack = false
// }
// async function fetchTotalViewSignedInUserForinsightInSevenDaysBack() {
//   fetchState.fetchingTotalViewSignedInUserForInsightInSevenDaysBack = true
//   const result = (await getTotalViewSignedInUserForInsightInSevenDaysBack())
//   totalViewUserInsight.value = result.data.data
//   fetchState.fetchingTotalViewSignedInUserForInsightInSevenDaysBack = false
// }
// async function fetchTotalViewNonUserForinsightInSevenDaysBack() {
//   fetchState.fetchingTotalViewNonUserForInsightInSevenDaysBack = true
//   const result = (await getTotalViewNonMemberForInsightInSevenDaysBack())
//   totalViewNonUserInsight.value = result.data.data
//   fetchState.fetchingTotalViewNonUserForInsightInSevenDaysBack = false
// }

// const totalViewResearchLabel = computed(()=>totalViewMergedResearch.value.map(item=>item.target_date.toString()))
// const totalViewResearchData = computed(()=>totalViewMergedResearch.value.map(item=>item.total))
const totalViewInsightLabel = computed(()=>totalViewMergedInsight.value.map(item=>item.target_date.toString()))
const totalViewInsightData = computed(()=>totalViewMergedInsight.value.map(item=>item.total))

setTimeout(() => {
  showNoPermission.value = true
}, 2000)

onBeforeMount(async () => {
  fetchTotalVerifiedUser()
  fetchTotalPublishedResearch()
  fetchTotalPublishedInsight()
  // fetchTotalViewSignedInUserForResearchInSevenDaysBack()
  // fetchTotalViewNonUserForResearchInSevenDaysBack()
  // fetchTotalViewSignedInUserForinsightInSevenDaysBack()
  // fetchTotalViewNonUserForinsightInSevenDaysBack()
})

onMounted(async () => {
  // setTimeout(() => {
  //   fetch
  //   fetchState.basicCount = false
  // }, 2500)
})

</script>

<template>
  <BaseLayout>
    <template #content>
      <div class="flex flex-col base-box-layout items-center lg:items-start lg:pl-[24px] gap-[8px]">
        <ForbiddenAccess
          v-show="
            userPermission.getUserPermission.read_action.length < 1 ||
            (userPermission.getUserPermission.read_action.length == 1 &&
              userPermission.getUserPermission.read_action[0] === '')
          "
          class="h-screen"
        />
        <TableContainer :appearance="false" class="!bg-transparent !border-0 !gap-[24px] !py-[8px] !mt-[0px] !px-0">
          <template #tableContent>
            <div class="grid md:grid-cols-3 grid-cols-1 gap-[24px] w-full">
              <basicAnalyticCard 
                v-show="userPermission.getUserPermission.read_action.includes(moduleName.USER_ANALYTIC)" 
                label="Total Verified User"
                :loading="fetchState.fetchingVerifiedUser"
                :value="totalVerifiedUser.toString()"
              >
                <template #icon>
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="28" height="28" rx="6" fill="#F4F3F7"/>
                      <path d="M13.3282 15.8696C13.9983 15.4234 14.507 14.7735 14.7792 14.0159C15.0514 13.2582 15.0725 12.4331 14.8395 11.6625C14.6064 10.8919 14.1316 10.2168 13.4852 9.73696C12.8388 9.25712 12.0551 8.99805 11.25 8.99805C10.445 8.99805 9.66131 9.25712 9.01489 9.73696C8.36847 10.2168 7.89363 10.8919 7.66059 11.6625C7.42754 12.4331 7.44867 13.2582 7.72084 14.0159C7.99301 14.7735 8.50178 15.4234 9.17191 15.8696C7.95971 16.3163 6.92447 17.1431 6.22066 18.2264C6.18367 18.2814 6.15797 18.3432 6.14507 18.4082C6.13217 18.4732 6.13231 18.5401 6.14549 18.605C6.15868 18.67 6.18464 18.7316 6.22187 18.7865C6.25909 18.8413 6.30684 18.8882 6.36235 18.9244C6.41785 18.9606 6.47999 18.9854 6.54516 18.9973C6.61033 19.0093 6.67724 19.0082 6.74198 18.9941C6.80672 18.98 6.86801 18.9531 6.92229 18.9151C6.97657 18.8771 7.02275 18.8287 7.05816 18.7727C7.51215 18.0744 8.13338 17.5006 8.86543 17.1034C9.59748 16.7062 10.4172 16.4982 11.25 16.4982C12.0829 16.4982 12.9026 16.7062 13.6346 17.1034C14.3667 17.5006 14.9879 18.0744 15.4419 18.7727C15.5152 18.8817 15.6285 18.9574 15.7573 18.9836C15.886 19.0097 16.0199 18.9841 16.1299 18.9124C16.2399 18.8406 16.3173 18.7284 16.3453 18.6001C16.3733 18.4717 16.3496 18.3375 16.2794 18.2264C15.5756 17.1431 14.5403 16.3163 13.3282 15.8696ZM8.50003 12.7496C8.50003 12.2057 8.66132 11.674 8.96349 11.2218C9.26566 10.7695 9.69515 10.417 10.1977 10.2089C10.7001 10.0008 11.2531 9.9463 11.7865 10.0524C12.32 10.1585 12.81 10.4204 13.1946 10.805C13.5792 11.1896 13.8411 11.6796 13.9472 12.2131C14.0533 12.7465 13.9988 13.2995 13.7907 13.8019C13.5826 14.3044 13.2301 14.7339 12.7778 15.0361C12.3256 15.3383 11.7939 15.4996 11.25 15.4996C10.5209 15.4987 9.82195 15.2087 9.3064 14.6932C8.79085 14.1777 8.50086 13.4787 8.50003 12.7496ZM21.6338 18.9183C21.5227 18.9907 21.3874 19.0161 21.2577 18.9888C21.1279 18.9615 21.0144 18.8837 20.9419 18.7727C20.4885 18.074 19.8673 17.5 19.1351 17.1029C18.4029 16.7059 17.583 16.4985 16.75 16.4996C16.6174 16.4996 16.4902 16.4469 16.3965 16.3531C16.3027 16.2594 16.25 16.1322 16.25 15.9996C16.25 15.867 16.3027 15.7398 16.3965 15.646C16.4902 15.5522 16.6174 15.4996 16.75 15.4996C17.155 15.4992 17.5549 15.4094 17.9212 15.2365C18.2874 15.0637 18.6109 14.8121 18.8687 14.4997C19.1264 14.1873 19.312 13.8218 19.4121 13.4294C19.5122 13.037 19.5244 12.6273 19.4478 12.2297C19.3713 11.832 19.2078 11.4561 18.9692 11.1289C18.7305 10.8018 18.4225 10.5313 18.0672 10.337C17.7119 10.1426 17.3181 10.0291 16.9139 10.0046C16.5096 9.9801 16.105 10.0452 15.7288 10.1952C15.6674 10.2217 15.6014 10.2357 15.5346 10.2362C15.4678 10.2368 15.4015 10.224 15.3398 10.1985C15.278 10.173 15.222 10.1354 15.175 10.0879C15.128 10.0404 15.091 9.98398 15.0661 9.92194C15.0413 9.8599 15.0292 9.79351 15.0305 9.72671C15.0317 9.6599 15.0464 9.59402 15.0736 9.53298C15.1007 9.47193 15.1399 9.41694 15.1886 9.37127C15.2374 9.3256 15.2948 9.29017 15.3575 9.26707C16.2184 8.92373 17.176 8.91137 18.0455 9.23239C18.915 9.5534 19.6348 10.185 20.066 11.0055C20.4973 11.8259 20.6094 12.7769 20.3808 13.6751C20.1523 14.5734 19.5991 15.3551 18.8282 15.8696C20.0403 16.3163 21.0756 17.1431 21.7794 18.2264C21.8518 18.3375 21.8772 18.4728 21.8499 18.6025C21.8226 18.7323 21.7448 18.8459 21.6338 18.9183Z" fill="#4448AB"/>
                  </svg>
                </template>
              </basicAnalyticCard>
              <basicAnalyticCard
                v-show="userPermission.getUserPermission.read_action.includes(moduleName.ALGO_RESEARCH_ANALYTIC)" 
                label="Total Published Research" 
                :loading="fetchState.fetchingPublishedResearch"
                :value="totalPublishedResearch.toString()"
              >
                <template #icon>
                  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.666626" width="28" height="28" rx="6" fill="#F3F7FB"/>
                    <path d="M12.1666 13C12.1666 12.8674 12.2193 12.7402 12.3131 12.6464C12.4068 12.5527 12.534 12.5 12.6666 12.5H17.6666C17.7992 12.5 17.9264 12.5527 18.0202 12.6464C18.1139 12.7402 18.1666 12.8674 18.1666 13C18.1666 13.1326 18.1139 13.2598 18.0202 13.3536C17.9264 13.4473 17.7992 13.5 17.6666 13.5H12.6666C12.534 13.5 12.4068 13.4473 12.3131 13.3536C12.2193 13.2598 12.1666 13.1326 12.1666 13ZM12.6666 15.5H17.6666C17.7992 15.5 17.9264 15.4473 18.0202 15.3536C18.1139 15.2598 18.1666 15.1326 18.1666 15C18.1666 14.8674 18.1139 14.7402 18.0202 14.6464C17.9264 14.5527 17.7992 14.5 17.6666 14.5H12.6666C12.534 14.5 12.4068 14.5527 12.3131 14.6464C12.2193 14.7402 12.1666 14.8674 12.1666 15C12.1666 15.1326 12.2193 15.2598 12.3131 15.3536C12.4068 15.4473 12.534 15.5 12.6666 15.5ZM21.1666 10V17.5C21.1666 17.8978 21.0086 18.2794 20.7273 18.5607C20.446 18.842 20.0645 19 19.6666 19H8.66663C8.26999 19 7.8895 18.8429 7.60839 18.5631C7.32728 18.2833 7.16844 17.9035 7.16663 17.5069V11.5C7.16663 11.3674 7.2193 11.2402 7.31307 11.1464C7.40684 11.0527 7.53402 11 7.66663 11C7.79923 11 7.92641 11.0527 8.02018 11.1464C8.11395 11.2402 8.16663 11.3674 8.16663 11.5V17.5C8.16663 17.6326 8.2193 17.7598 8.31307 17.8536C8.40684 17.9473 8.53402 18 8.66663 18C8.79923 18 8.92641 17.9473 9.02018 17.8536C9.11395 17.7598 9.16663 17.6326 9.16663 17.5V10C9.16663 9.73478 9.27198 9.48043 9.45952 9.29289C9.64706 9.10536 9.90141 9 10.1666 9H20.1666C20.4318 9 20.6862 9.10536 20.8737 9.29289C21.0613 9.48043 21.1666 9.73478 21.1666 10ZM20.1666 10H10.1666V17.5C10.1669 17.6703 10.1379 17.8395 10.081 18H19.6666C19.7992 18 19.9264 17.9473 20.0202 17.8536C20.1139 17.7598 20.1666 17.6326 20.1666 17.5V10Z" fill="#3E91C9"/>
                  </svg>
                </template>
              </basicAnalyticCard>
              <basicAnalyticCard 
              v-show="userPermission.getUserPermission.read_action.includes(moduleName.ALGO_NEWS_ANALYTIC)" 
              label="Total Published Insight" 
              :loading="fetchState.fetchingPublishedNews"
              :value="totalPublishedNews.toString()"
              >
                <template #icon>
                  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.333252" width="28" height="28" rx="6" fill="#F3F7FB"/>
                    <path d="M9.83325 14.5C9.83325 14.6326 9.78057 14.7598 9.68681 14.8536C9.59304 14.9473 9.46586 15 9.33325 15H7.83325C7.70064 15 7.57347 14.9473 7.4797 14.8536C7.38593 14.7598 7.33325 14.6326 7.33325 14.5C7.33325 14.3674 7.38593 14.2402 7.4797 14.1464C7.57347 14.0527 7.70064 14 7.83325 14H8.33325V10H7.83325C7.70064 10 7.57347 9.94732 7.4797 9.85355C7.38593 9.75979 7.33325 9.63261 7.33325 9.5C7.33325 9.36739 7.38593 9.24022 7.4797 9.14645C7.57347 9.05268 7.70064 9 7.83325 9H8.83325C8.9179 8.99991 9.00118 9.02131 9.07529 9.06219C9.14941 9.10308 9.21193 9.16211 9.257 9.23375L11.3333 12.5569L13.4095 9.235C13.4544 9.16312 13.5169 9.10385 13.591 9.06274C13.6651 9.02163 13.7485 9.00004 13.8333 9H14.8333C14.9659 9 15.093 9.05268 15.1868 9.14645C15.2806 9.24022 15.3333 9.36739 15.3333 9.5C15.3333 9.63261 15.2806 9.75979 15.1868 9.85355C15.093 9.94732 14.9659 10 14.8333 10H14.3333V14H14.8333C14.9659 14 15.093 14.0527 15.1868 14.1464C15.2806 14.2402 15.3333 14.3674 15.3333 14.5C15.3333 14.6326 15.2806 14.7598 15.1868 14.8536C15.093 14.9473 14.9659 15 14.8333 15H13.3333C13.2006 15 13.0735 14.9473 12.9797 14.8536C12.8859 14.7598 12.8333 14.6326 12.8333 14.5C12.8333 14.3674 12.8859 14.2402 12.9797 14.1464C13.0735 14.0527 13.2006 14 13.3333 14V11.2431L11.757 13.765C11.712 13.8368 11.6496 13.896 11.5754 13.937C11.5013 13.9781 11.418 13.9996 11.3333 13.9996C11.2485 13.9996 11.1652 13.9781 11.0911 13.937C11.017 13.896 10.9545 13.8368 10.9095 13.765L9.33325 11.2431V14C9.46586 14 9.59304 14.0527 9.68681 14.1464C9.78057 14.2402 9.83325 14.3674 9.83325 14.5ZM16.8333 13H20.8333C20.9659 13 21.093 12.9473 21.1868 12.8536C21.2806 12.7598 21.3333 12.6326 21.3333 12.5C21.3333 12.3674 21.2806 12.2402 21.1868 12.1464C21.093 12.0527 20.9659 12 20.8333 12H16.8333C16.7006 12 16.5735 12.0527 16.4797 12.1464C16.3859 12.2402 16.3333 12.3674 16.3333 12.5C16.3333 12.6326 16.3859 12.7598 16.4797 12.8536C16.5735 12.9473 16.7006 13 16.8333 13ZM20.8333 14H16.8333C16.7006 14 16.5735 14.0527 16.4797 14.1464C16.3859 14.2402 16.3333 14.3674 16.3333 14.5C16.3333 14.6326 16.3859 14.7598 16.4797 14.8536C16.5735 14.9473 16.7006 15 16.8333 15H20.8333C20.9659 15 21.093 14.9473 21.1868 14.8536C21.2806 14.7598 21.3333 14.6326 21.3333 14.5C21.3333 14.3674 21.2806 14.2402 21.1868 14.1464C21.093 14.0527 20.9659 14 20.8333 14ZM20.8333 16H11.3333C11.2006 16 11.0735 16.0527 10.9797 16.1464C10.8859 16.2402 10.8333 16.3674 10.8333 16.5C10.8333 16.6326 10.8859 16.7598 10.9797 16.8536C11.0735 16.9473 11.2006 17 11.3333 17H20.8333C20.9659 17 21.093 16.9473 21.1868 16.8536C21.2806 16.7598 21.3333 16.6326 21.3333 16.5C21.3333 16.3674 21.2806 16.2402 21.1868 16.1464C21.093 16.0527 20.9659 16 20.8333 16ZM20.8333 18H11.3333C11.2006 18 11.0735 18.0527 10.9797 18.1464C10.8859 18.2402 10.8333 18.3674 10.8333 18.5C10.8333 18.6326 10.8859 18.7598 10.9797 18.8536C11.0735 18.9473 11.2006 19 11.3333 19H20.8333C20.9659 19 21.093 18.9473 21.1868 18.8536C21.2806 18.7598 21.3333 18.6326 21.3333 18.5C21.3333 18.3674 21.2806 18.2402 21.1868 18.1464C21.093 18.0527 20.9659 18 20.8333 18Z" fill="#3E91C9"/>
                  </svg>
                </template>
              </basicAnalyticCard>
            </div>
            <TotalViewResearchAndInsight />
            <TotalViewResearch />
            <TotalViewInsight />
            <TotalViewInstitution />
            <TotalViewCircle />
          </template>
        </TableContainer>
      </div>
    </template>
  </BaseLayout>
</template>
<style>
/* page settings */
.base-box-layout {
  background: var(--Accent-Color-Slate-50, #f8fafc);
  padding-top: 24px;
  padding-bottom: 24px;
}

/* item box setting */
</style>
